/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import styled from "@emotion/styled";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { apiRequest } from "../../../common/common";
import { useParams } from "react-router-dom"
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { LoadingPage } from '../../../common/LoadingPage';
import { ArchitecturalCode, ConnectionType, DissipationType, DrainLocation, ElectricalPhase, GasLocation, GasType, getSize, getWeight, Mounting, Network, PlugType, ProductType, Responsibility, Shielding, ThreeDAccess, TwoDAccess, Units, VentType, VoltageType } from '../../../common/const';
import { showNotification } from '../../../common/Notification/ToastifyNotification';
import AddItemInProject from './addItemInProject';
import { useSelector } from 'react-redux';

const DividerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(0, 1),
    minHeight: 50
}));

const DemoGrid = styled(Grid)(({ theme }) => ({
    border: '1px solid lightgray',
    padding: 10
}));

const DemoTypography = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: 13
}));

const DemoTypo = styled(Typography)(({ theme }) => ({
    fontSize: 13
}));

const HeadingTypo = styled(Typography)(({ theme }) => ({
    fontSize: 16,
    borderBottom: '2px solid #3f51b5',
    marginBottom: 10,
}));

const Cell = styled(TableCell)({
    padding: '0px 0px 0px 20px'
});

export default function ProductDetails() {
    const { id, from } = useParams();
    const { roles, user } = useSelector(state => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const currentPlanId = user?.organization?.Subscriptions[0]?.plan_id;
    const [dataLoading, setDataLoding] = useState(false);
    const [productData, setProductData] = useState(null);
    const [catalogOpen, setCatalogOpen] = useState(false);
    const [rows, setRows] = useState(from === 'tm' ? [
        { extension: '--', type: 'Image', resource: '--', size: '--', sortUrl: '' }
    ] : [
        { extension: '--', type: 'Image', resource: '--', size: '--', sortUrl: '' },
        { extension: '--', type: 'Product Specification', resource: '--', size: '--', sortUrl: '' },
        { extension: '--', type: 'Product Brochure', resource: '--', size: '--', sortUrl: '' },
        { extension: '--', type: 'Product Planning', resource: '--', size: '--', sortUrl: '' },
        { extension: '--', type: 'Product Operating Manual', resource: '--', size: '--', sortUrl: '' },
        { extension: '--', type: 'URL', resource: '--', size: '--', sortUrl: '' },
        { extension: '--', type: '2D', resource: '--', size: '--', sortUrl: '' },
        { extension: '--', type: '3D', resource: '--', size: '--', sortUrl: '' },
        { extension: '--', type: 'Other Document', resource: '--', size: '--', sortUrl: '' },
    ]);
    useEffect(() => {
        const fetchData = async () => {
            if (id) {
                try {
                    setDataLoding(true);
                    const response = await apiRequest('get', `/product/${id}`);
                    if (response?.data) {
                        const { data } = response?.data;
                        setProductData(response?.data?.data);
                        const getFileData = (key) => {
                            const file = data?.[key]?.[0];
                            if (!file) return {};
                            return {
                                resource: file?.fileName || file?.sortUrl.split('/').pop().split('&')[0].split(/\.(?=[^\.]+$)/)[0],
                                size: file.size ? `${(file.size / 1024).toFixed(2)} KB` : '--',
                                extension: file?.fileName?.split('.')?.pop() || file?.sortUrl.split('/').pop().split('&')[0].split(/\.(?=[^\.]+$)/)[1] || '--',
                                sortUrl: file?.sortUrl
                            };
                        };
                        setRows((prevData) =>
                            prevData.map((row) => {
                                if (row.type === 'Image') {
                                    return { ...row, ...getFileData('images') };
                                }
                                if (row.type === 'Product Specification') {
                                    return { ...row, ...getFileData('specifications_doc') };
                                }
                                if (row.type === 'Product Brochure') {
                                    return { ...row, ...getFileData('brochure_doc') };
                                }
                                if (row.type === 'Product Planning') {
                                    return { ...row, ...getFileData('site_planning_doc') };
                                }
                                if (row.type === 'Product Operating Manual') {
                                    return { ...row, ...getFileData('operating_manual_doc') };
                                }
                                if (row.type === '2D') {
                                    return { ...row, ...getFileData('twod_doc') };
                                }
                                if (row.type === '3D') {
                                    return { ...row, ...getFileData('threed_doc') };
                                }
                                if (row.type === 'Other Document') {
                                    return { ...row, ...getFileData('documents') };
                                }
                                if (row.type === 'URL') {
                                    const resourceValue = data?.["website_url"]?.length === 0 ? '--' : data?.["website_url"].toString();
                                    return {
                                        ...row,
                                        resource: resourceValue,
                                        extension: resourceValue !== '--' ? 'URL' : '--',
                                    };
                                }
                                return row;
                            })
                        );
                        setDataLoding(false)
                    }
                } catch (error) {
                    setDataLoding(false);
                    showNotification(error?.response?.data.error || error.message, 'error');
                }
            }
        };
        fetchData();
    }, [id]);

    const { clearance, electrical_data, mechanical_data, plumbing_data, tech_connection_data } = productData || {};

    return (
        productData !== null ? (
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <DividerHeader />
                <Box item xs={12} sm={12} md={12} lg={12}>
                    <Accordion defaultExpanded>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Typography variant="h6" style={{ fontSize: 18 }}>Details</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container>
                                <Grid item xs={6} sm={4}>
                                    <Box display="flex" gap={2}>
                                        <img
                                            src={productData?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${productData?.images?.[0]?.sortUrl}}&uid=${user?.user_id}` : 'https://dummyimage.com/100x100/000/fff'}
                                            style={{ width: 80, border: '2px solid black', height: '60px' }}
                                        />
                                        <img
                                            src={productData?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${productData?.images?.[0]?.sortUrl}}&uid=${user?.user_id}` : 'https://dummyimage.com/100x100/000/fff'}
                                            style={{ width: 250, border: '2px solid black', height: '187.5px', imageRendering: 'auto' }}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={6} sm={4} style={{ paddingRight: 10 }}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <DemoTypo variant="body2">{`${productData?.category?.name || ''}:${productData?.["sub_category"]?.name || ''}`}</DemoTypo>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <DemoTypo variant="body2">{`${productData?.manufacturer?.name || '--'} | ${productData?.model}`}</DemoTypo>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <DemoTypo variant="body2">{`Numeric ID: ${productData?.is_customer_product ? `C-${productData?.alternate_id}` : `${productData?.category?.["sku_no"] || ''}${productData?.sub_category?.["sku_no"] || ''}-${String(productData?.["numaric_sku"]).padStart(3, '0')}`}` || '--'}</DemoTypo>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <DemoTypo variant="body2">{`Alphanumeric ID:${productData?.is_customer_product ? `C-${productData?.alternate_id}` : `${productData?.category?.["prefix"] || ''}${productData?.sub_category?.["prefix"] || ''}-${String(productData?.["numaric_sku"]).padStart(3, '0')}`}` || '--'}</DemoTypo>
                                        </Grid>
                                        <Grid>
                                            {catalogOpen && (
                                                <AddItemInProject
                                                    catalogOpen={catalogOpen}
                                                    setCatalogOpen={setCatalogOpen}
                                                    selectedData={[productData]}
                                                />
                                            )}
                                            <Box display="flex" gap={2} m={1}>
                                                <Typography variant='h5' style={{ fontWeight: 'bold' }}>{`₹ ${Intl.NumberFormat('en-IN').format(productData?.list_price)}`}</Typography>
                                                {currentPlanId !== 7 && (
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        color="primary"
                                                        style={{ height: 30 }}
                                                        onClick={() =>
                                                            setCatalogOpen(true)
                                                        }
                                                    >
                                                        Add To Project
                                                    </Button>
                                                )}
                                            </Box>
                                            <Box display="flex" gap="2" m={1}>
                                                <Typography variant='body1' style={{ fontWeight: 'bold', color: "#3f51b5" }}>{`Product ${productData?.price_type === 'list' ? 'List' : 'Estimated'} Price`}</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <DemoTypo variant="body2">{productData?.description}</DemoTypo>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6} sm={4}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Type:</DemoTypography>
                                                <DemoTypo variant="body2">{ProductType?.find((a) => a.value === productData?.type)?.name || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Responsibility Code:</DemoTypography>
                                                <DemoTypo variant="body2">{`${Responsibility.find((a) => a.value === productData?.furnish_responsibility)?.name ? `${Responsibility.find((a) => a.value === productData?.furnish_responsibility)?.name} furnish` : '--'} / ${Responsibility.find((a) => a.value === productData?.furnish_responsibility)?.name ? `${Responsibility.find((a) => a.value === productData?.install_responsibility)?.name} Install` : '--'}`}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Life Expectancy/Lifespan:</DemoTypography>
                                                <DemoTypo variant="body2">{productData?.life_expectancy ? `${productData?.life_expectancy} years` : '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Lead Time:</DemoTypography>
                                                <DemoTypo variant="body2">{productData?.lead_time ? `${productData?.lead_time} days` : '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Architectural Code:</DemoTypography>
                                                <DemoTypo variant="body2">{ArchitecturalCode?.find((a) => a.value === productData?.architectural_code)?.name || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Architecturally Significant:</DemoTypography>
                                                <DemoTypo variant="body2">{productData?.architecturally_significant ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Spatially Significant:</DemoTypography>
                                                <DemoTypo variant="body2">{productData?.spatially_significant ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">International:</DemoTypography>
                                                <DemoTypo variant="body2">{productData?.international ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2-content"
                            id="panel2-header"
                        >
                            <Typography variant="h6" style={{ fontSize: 18 }}>Physical</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container>
                                <DemoGrid item xs={12} sm={6} md={3}>
                                    <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Dimensions</HeadingTypo>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Units:</DemoTypography>
                                                <DemoTypo variant="body2">{Units?.find((a) => a.value === productData?.units)?.name || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Width:</DemoTypography>
                                                <DemoTypo variant="body2">{getSize(productData?.units, productData?.width) || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Height:</DemoTypography>
                                                <DemoTypo variant="body2">{getSize(productData?.units, productData?.height) || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Depth:</DemoTypography>
                                                <DemoTypo variant="body2">{getSize(productData?.units, productData?.depth) || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box>
                                                <DemoTypography variant="body2">Spatial Remarks:</DemoTypography>
                                                <Typography variant="body2" sx={{ fontSize: 12 }}>{productData?.spatial_remarks || '--'}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </DemoGrid>
                                <DemoGrid item xs={12} sm={6} md={3}>
                                    <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Clearance</HeadingTypo>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" gap={1}>
                                                <DemoTypography variant="body2">Left:</DemoTypography>
                                                <DemoTypo variant="body2">{getSize(productData?.units, clearance?.left) || '--'}</DemoTypo>
                                            </Box>
                                            <Box display="flex" gap={1}>
                                                <DemoTypography variant="body2">Right:</DemoTypography>
                                                <DemoTypo variant="body2">{getSize(productData?.units, clearance?.right) || '--'}</DemoTypo>
                                            </Box>
                                            <Box display="flex" gap={1}>
                                                <DemoTypography variant="body2">Top:</DemoTypography>
                                                <DemoTypo variant="body2">{getSize(productData?.units, clearance?.top) || '--'}</DemoTypo>
                                            </Box>
                                            <Box display="flex" gap={1}>
                                                <DemoTypography variant="body2">Bottom:</DemoTypography>
                                                <DemoTypo variant="body2">{getSize(productData?.units, clearance?.bottom) || '--'}</DemoTypo>
                                            </Box>
                                            <Box display="flex" gap={1}>
                                                <DemoTypography variant="body2">Front:</DemoTypography>
                                                <DemoTypo variant="body2">{getSize(productData?.units, clearance?.front) || '--'}</DemoTypo>
                                            </Box>
                                            <Box display="flex" gap={1}>
                                                <DemoTypography variant="body2">Back:</DemoTypography>
                                                <DemoTypo variant="body2">{getSize(productData?.units, clearance?.back) || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </DemoGrid>
                                <DemoGrid item xs={12} sm={6} md={3}>
                                    <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Weights</HeadingTypo>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Mouting:</DemoTypography>
                                                <DemoTypo variant="body2">{Mounting.find((a) => a.value === productData?.mounting)?.name || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Product Weight:</DemoTypography>
                                                <DemoTypo variant="body2">{getWeight(productData?.units, productData?.max_weight) || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Ship Weight:</DemoTypography>
                                                <DemoTypo variant="body2">{getWeight(productData?.units, productData?.ship_weight) || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </DemoGrid>
                                <DemoGrid item xs={12} sm={6} md={3}>
                                    <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Attributes</HeadingTypo>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">DA Compliant:</DemoTypography>
                                                <DemoTypo variant="body2">{productData?.da_complient ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Anti-Microbial:</DemoTypography>
                                                <DemoTypo variant="body2">{productData?.antimicrobial ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Green:</DemoTypography>
                                                <DemoTypo variant="body2">{productData?.green ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Shielding:</DemoTypography>
                                                <DemoTypo variant="body2">{Shielding?.find((a) => a.value === productData?.Shielding)?.name || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Seismic:</DemoTypography>
                                                <DemoTypo variant="body2">{productData?.seismic ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </DemoGrid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel3-content"
                            id="panel3-header"
                        >
                            <Typography variant="h6" style={{ fontSize: 18 }}>Utilites</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container>
                                <DemoGrid item xs={12} sm={6} md={3}>
                                    <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Mechanical</HeadingTypo>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Vent:</DemoTypography>
                                                <DemoTypo variant="body2">{mechanical_data?.vent ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">VentType:</DemoTypography>
                                                <DemoTypo variant="body2">{mechanical_data?.vent ? (VentType?.find((a) => a.value === mechanical_data?.ventType)?.name || '--') : '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Heat Dissipation (BTU/hr):</DemoTypography>
                                                <DemoTypo variant="body2">{mechanical_data?.heatDissipation ? `${mechanical_data?.heatDissipation} BTUs/hr` : '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Dissipation Type:</DemoTypography>
                                                <DemoTypo variant="body2">{DissipationType.find((a) => a.value === mechanical_data?.dissipationType)?.name || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box>
                                                <DemoTypography variant="body2">Remarks:</DemoTypography>
                                                <Typography variant="body2" sx={{ fontSize: 12 }}>{mechanical_data?.mechanicalRemarks || '--'}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </DemoGrid>
                                <DemoGrid item xs={12} sm={6} md={3}>
                                    <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Electrical</HeadingTypo>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Voltage Type:</DemoTypography>
                                                <DemoTypo variant="body2">{VoltageType.find((a) => a.value === electrical_data?.voltageType)?.name || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Volts:</DemoTypography>
                                                <DemoTypo variant="body2">{electrical_data?.volts ? `${electrical_data?.volts} V` : '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Amps:</DemoTypography>
                                                <DemoTypo variant="body2">{electrical_data?.amps ? `${electrical_data?.amps} A` : '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Watts:</DemoTypography>
                                                <DemoTypo variant="body2">{electrical_data?.watts ? `${electrical_data?.watts} W` : '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">kVA:</DemoTypography>
                                                <DemoTypo variant="body2">{electrical_data?.kva ? `${electrical_data?.kva} kVA` : '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Hertz:</DemoTypography>
                                                <DemoTypo variant="body2">{electrical_data?.hertz ? `${electrical_data?.hertz} Hz` : '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Phase:</DemoTypography>
                                                <DemoTypo variant="body2">{ElectricalPhase.find((a) => a.value === electrical_data?.electricalPhase)?.name || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Plug Type:</DemoTypography>
                                                <DemoTypo variant="body2">{PlugType.find((a) => a.value === electrical_data?.plugtype)?.name || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" gap={1}>
                                                <DemoTypography variant="body2">Plug Details:</DemoTypography>
                                                <DemoTypo variant="body2">{electrical_data?.plugdetail || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Dedicated Circuit:</DemoTypography>
                                                <DemoTypo variant="body2">{electrical_data?.dedicatedCircuit ? 'Manufacturer Recommended' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Emergency Power:</DemoTypography>
                                                <DemoTypo variant="body2">{electrical_data?.emergencyPower ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Remote Transformer:</DemoTypography>
                                                <DemoTypo variant="body2">{electrical_data?.remoteTrans ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Remote Switch/Controller:</DemoTypography>
                                                <DemoTypo variant="body2">{electrical_data?.remoteSwitch ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box>
                                                <DemoTypography variant="body2">Remarks:</DemoTypography>
                                                <Typography variant="body2" sx={{ fontSize: 12 }}>{electrical_data?.electricalRemarks || '--'}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </DemoGrid>
                                <DemoGrid item xs={12} sm={6} md={3}>
                                    <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Plumbing</HeadingTypo>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Water Cold:</DemoTypography>
                                                <DemoTypo variant="body2">{plumbing_data?.coldWater ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Water Hot:</DemoTypography>
                                                <DemoTypo variant="body2">{plumbing_data?.hotWater ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Water Treated:</DemoTypography>
                                                <DemoTypo variant="body2">{plumbing_data?.treatedWater ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Steam:</DemoTypography>
                                                <DemoTypo variant="body2">{plumbing_data?.steam ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Vaccum-Medical:</DemoTypography>
                                                <DemoTypo variant="body2">{plumbing_data?.vaccumMedical ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Vaccum-Dental:</DemoTypography>
                                                <DemoTypo variant="body2">{plumbing_data?.vaccumDental ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Drain:</DemoTypography>
                                                <DemoTypo variant="body2">{plumbing_data?.drain ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Drain Location:</DemoTypography>
                                                <DemoTypo variant="body2">{DrainLocation.find((a) => a.value === plumbing_data?.drainLocation)?.name || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Medical Gas:</DemoTypography>
                                                <DemoTypo variant="body2">{plumbing_data?.medicalGas ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" gap={1}>
                                                <DemoTypography variant="body2">Gas Type:</DemoTypography>
                                                <DemoTypo variant="body2">
                                                    {plumbing_data?.gasType?.length > 0
                                                        ? GasType.filter((a) => plumbing_data?.gasType?.includes(a.value))
                                                            .map((a, index) => (
                                                                <span key={index}>
                                                                    {a.name}
                                                                    <br />
                                                                </span>
                                                            ))
                                                        : '--'}
                                                </DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Gas Location:</DemoTypography>
                                                <DemoTypo variant="body2">{GasLocation.find((a) => a.value === plumbing_data?.gasLocation)?.name || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box>
                                                <DemoTypography variant="body2">Remarks:</DemoTypography>
                                                <Typography variant="body2" sx={{ fontSize: 12 }}>{plumbing_data?.plumbingRemarks || '--'}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </DemoGrid>
                                <DemoGrid item xs={12} sm={6} md={3}>
                                    <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Tech Connection</HeadingTypo>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Has Technical Connection:</DemoTypography>
                                                <DemoTypo variant="body2">{tech_connection_data?.isConnection ? 'Yes' : 'No'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">ConnectionType:</DemoTypography>
                                                <DemoTypo variant="body2">{ConnectionType?.find((a) => a.value === tech_connection_data?.connectionType)?.name || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <DemoTypography variant="body2">Network:</DemoTypography>
                                                <DemoTypo variant="body2">{Network.find((a) => a.value === tech_connection_data?.network)?.name || '--'}</DemoTypo>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Box>
                                                <DemoTypography variant="body2">Remarks:</DemoTypography>
                                                <Typography variant="body2" sx={{ fontSize: 12 }}>{tech_connection_data?.techRemarks || '--'}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </DemoGrid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4-content"
                            id="panel4-header"
                        >
                            <Typography variant="h6" style={{ fontSize: 18 }}>Resources</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                                <TableContainer>
                                    <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                                        <TableHead>
                                            <TableRow>
                                                <Cell>Extension</Cell>
                                                <Cell>Type</Cell>
                                                <Cell>Resource</Cell>
                                                <Cell>Size</Cell>
                                                <Cell>Action</Cell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rows.map((row, index) => {
                                                const is2D = row.type === '2D';
                                                const is3D = row.type === '3D';
                                                const isAdmin = ['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code);

                                                // Determine if the current plan allows access based on type
                                                const hasAccess2D = is2D && (isAdmin || TwoDAccess.includes(currentPlanId));
                                                const hasAccess3D = is3D && (isAdmin || ThreeDAccess === currentPlanId);
                                                const hasAccessOtherTypes = !is2D && !is3D;

                                                // Calculate the button's disabled state based on the conditions
                                                const isButtonDisabled = !(hasAccess2D || hasAccess3D || hasAccessOtherTypes);
                                                return (
                                                    <TableRow key={index} sx={{ padding: 10 }}>
                                                        <Cell>
                                                            <Box style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                                                {(row.extension !== '--' && row?.type === 'Image') ? (
                                                                    <img src="/images/gallary.png" alt="blog img" style={{ width: 20 }} />
                                                                ) : (row.extension !== '--' && row?.type === '2D') ? (
                                                                    <img src="/images/autocad.png" alt="blog img" style={{ width: 20 }} />
                                                                ) : (row.extension !== '--' && row?.type === '3D') ? (
                                                                    <img src="/images/ravit.jpeg" alt="blog img" style={{ width: 20 }} />
                                                                ) : (row.extension !== '--' && row?.type === 'URL') ? (
                                                                    <img src="/images/URL.png" alt="blog img" style={{ width: 20 }} />
                                                                ) : row.extension !== '--' && (
                                                                    <img src="/images/pdf.svg" alt="blog img" style={{ width: 15 }} />
                                                                )}
                                                                {row.extension}
                                                            </Box>
                                                        </Cell>
                                                        <Cell>{row.type}</Cell>
                                                        <Cell>
                                                            {row.type === 'URL' ? (
                                                                row?.resource !== '--' && row?.resource?.split(',').map((a) => (
                                                                    <>
                                                                        <Tooltip title={a}>
                                                                            <a href={a} target="_blank" rel="noreferrer">{a.slice(0, 50)}</a>
                                                                        </Tooltip>
                                                                        <br />
                                                                    </>
                                                                ))
                                                            ) :
                                                                row.resource}
                                                        </Cell>
                                                        <Cell>{row.size}</Cell>
                                                        <Cell>
                                                            {row.extension !== '--' && row.type !== 'URL' ? (
                                                                <a
                                                                    href='#'
                                                                    style={{ color: isButtonDisabled ? 'gray' : '' }}
                                                                    onClick={async () => {
                                                                        if (!isButtonDisabled) {
                                                                            const url = `${process.env.REACT_APP_IMAGEURL}bbn=${row?.sortUrl}&uid=${user?.user_id}`;
                                                                            const response = await fetch(url, { method: 'GET' });
                                                                            const blob = await response.blob();
                                                                            const link = document.createElement('a');
                                                                            link.href = window.URL.createObjectURL(blob);
                                                                            link.download = `${row?.resource}`; // <-- set file name here
                                                                            link.click();
                                                                        }
                                                                    }}
                                                                >
                                                                    <FileDownloadIcon />
                                                                </a>
                                                            ) : '--'}
                                                        </Cell>
                                                    </TableRow>
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                </Box>
            </Box>
        ) : (<LoadingPage isLoading={dataLoading} />)
    )
}